/* 写真が刷るように出る（2026-10-02・TOPと和について・ご褒美シリーズのページ）。v6 で採用した「スクロールすると写真が捲れる」動き（左から刷り出し→朱の版が右下にずれて赤い枠が残る）を、本番の写真に付ける。
   ・対象：TOPの各章（kazu-*）の写真。FV・ヘッダー・フッター・カート・小さい画像（幅140px未満）・隠れている写真・data-kz-norv の中（01の切り替え写真など、自分で刷り出すもの）は除く。
   ・読み込み開始時にすでに画面に入っている写真には付けない（一度見えた写真が消えないように）。
   ・写真を隠したままだと遅延読み込みが始まらないので、近づいたら先に読み込み、読み込めてから刷り出す。
   ・横に送る札（スマホ）は、横に送って見えたときに刷り出す。動きを減らす設定では何もしない。 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  /* TOPの各章（kazu_*）、和についてのページ（kazu-about）、私のご褒美シリーズのページ（kgr-detail）。
     作り方のページは独自の動き、商品・一覧は写真の切り替えがあるので、今は付けない */
  const sel = '.shopify-section[id*="kazu_"]:not([id*="kazu_fv22"]) img, main section.kazu-about img, main section.kgr-detail img';
  const vh = () => window.innerHeight || document.documentElement.clientHeight;
  const ok = (img) => {
    if (img.closest('[hidden], [data-kz-norv], header, footer, #cart-drawer, .kazu-fv22, kazu-fv22, button, [role="button"]')) return false;
    const r = img.getBoundingClientRect();
    if (r.width < 140 || r.height < 100) return false;
    if (r.top < vh() && r.bottom > 0 && r.left < window.innerWidth && r.right > 0) return false; /* もう見えている */
    return true;
  };
  const pre = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    pre.unobserve(e.target);
    if (e.target.__kzImg) e.target.__kzImg.loading = 'eager';
  }), { rootMargin: '150% 0px 150% 0px' });
  /* 隠した写真そのものは「見えていない」扱いになるので、写真の枠（親）が画面に入ったかで判断する */
  const go = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    const img = e.target.__kzImg;
    if (!img) return;
    go.unobserve(e.target);
    const frame = img.__kzFrame;
    const show = () => requestAnimationFrame(() => { img.classList.add('is-in'); if (frame) frame.classList.add('is-in'); });
    if (img.complete && img.naturalWidth) show();
    else { img.loading = 'eager'; img.addEventListener('load', show, { once: true }); img.addEventListener('error', show, { once: true }); setTimeout(show, 2500); }
  }), { threshold: .35, rootMargin: '0px 0px -8% 0px' });
  const run = () => {
    document.querySelectorAll(sel).forEach((img) => {
      if (img.dataset.kzRv || !ok(img)) return;
      img.dataset.kzRv = '1';
      img.classList.add('kz-rv');
      /* 写真と同じ大きさの枠にだけ、刷る前の版の色を敷く（大きな箱には敷かない） */
      const host = img.parentElement;
      if (host) {
        if (host.offsetWidth * host.offsetHeight <= img.offsetWidth * img.offsetHeight * 1.15) host.classList.add('kz-rv-host');
      }
      /* 朱の版をずらす枠：写真と同じ大きさのいちばん外側の箱（中の overflow で切られないように）。札（横送り）の中は枠を付けない */
      if (!img.closest('.kzt__card')) {
        /* 大きさは配置上の値で比べる（刷り出し前の少し寄せた拡大は含めない） */
        let f = img.parentElement; let best = null;
        const iw = img.offsetWidth; const ih = img.offsetHeight;
        while (f && !f.classList.contains('shopify-section')) {
          if (Math.abs(f.offsetWidth - iw) <= 6 && Math.abs(f.offsetHeight - ih) <= 6) { best = f; f = f.parentElement; } else break;
        }
        if (best) { best.classList.add('kz-rv-frame'); img.__kzFrame = best; }
      }
      const box = img.parentElement || img;
      box.__kzImg = img;
      pre.observe(box);
      go.observe(box);
    });
  };
  if (document.readyState === 'complete') run(); else window.addEventListener('load', run, { once: true });
})();
